import * as React from 'react'
import { FC } from 'react'

import { EmbroideryFormKind } from '../../../../containers/EmbroideryService/types'
import { EmbroideryVariant, Variant } from '../../../../types/graphql'
import { DTCLogoEmbroideryForm } from '../../forms/DTCLogoEmbroideryForm'
import { IconEmbroideryForm } from '../../forms/IconEmbroideryForm'
import { IFormProps } from '../../forms/IFormProps'
import { LogoEmbroideryForm } from '../../forms/LogoEmbroideryForm'
import { TextEmbroideryForm } from '../../forms/TextEmbroideryForm'

type DefaultEmbroideryComponent = FC<IFormProps<EmbroideryVariant>>
type LogoEmbroideryComponent = FC<IFormProps<Variant>>

const formsByKind: Record<
  EmbroideryFormKind,
  FC<IFormProps<EmbroideryVariant>> | FC<IFormProps<Variant>>
> = {
  ICON_ONLY: IconEmbroideryForm as DefaultEmbroideryComponent,
  TEXT_ONLY: TextEmbroideryForm as DefaultEmbroideryComponent,
  LOGO_ONLY: LogoEmbroideryForm as LogoEmbroideryComponent,
  LOGO_SETUP: DTCLogoEmbroideryForm as LogoEmbroideryComponent,
  ADD_LOGO: DTCLogoEmbroideryForm as LogoEmbroideryComponent,
}

export const EmbroideryForm: FC<IFormProps & { formKind: EmbroideryFormKind }> = props => {
  const Form: FC<IFormProps<EmbroideryVariant>> | FC<IFormProps<Variant>> = (function () {
    return formsByKind[props.formKind]
  })()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Form {...(props as any)} />
}
